import * as SeparatorPrimitive from "@radix-ui/react-separator";
import type * as React from "react";

import { cn } from "./utils";

function Separator({
  className,
  orientation = "horizontal",
  decorative = true,
  thickness = "2px",
  ...props
}: React.ComponentProps<typeof SeparatorPrimitive.Root> & {
  thickness?: string | undefined;
}) {
  return (
    <SeparatorPrimitive.Root
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      style={
        {
          "--thickness": thickness,
        } as React.CSSProperties
      }
      className={cn(
        "bg-border shrink-0 data-[orientation=horizontal]:h-(--thickness) data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-(--thickness)",
        className,
      )}
      {...props}
    />
  );
}

export { Separator };
